function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import { Button, Card, Badge } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "./InputActivityReport.css";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "./../SideMenu/Header";
import { HiDownload, HiOutlineSelector, HiChevronDown, HiChevronUp } from "react-icons/hi";
import { useTable, useSortBy } from "react-table";
import { GET_USER_LISTING_QUERY } from "./../MonthlyAttendance/query";
import Loader from "./../Loader/Loader";
import { FilterContext, UserContext } from "../index";
import { useQuery, useLazyQuery } from "@apollo/client";
import { INPUT_ACTIVITY_REPORT_QUERY, INPUT_ACTIVITY_REPORT_EXPORT_QUERY, INPUT_ACTIVITY_REPORT_HEADER_QUERY } from "./query";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend } from "chart.js";
import { subDays } from "date-fns";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Tooltip as BootstrapTooltip } from "react-bootstrap";
import { PlanUpgradeMessage } from "../WorkLoadAnalysisReport/WorkLoadAnalysisReport";
var LIMIT = 100;
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend);
var InputActivityReport = function InputActivityReport(props) {
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    sD = _React$useContext.startDate,
    eD = _React$useContext.endDate,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var _React$useState = React.useState(startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("day").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    startDate = _React$useState2[0],
    setStartDate = _React$useState2[1];

  //   console.log({ startDate });

  var _React$useState3 = React.useState({
      label: user.displayName,
      value: user.userId
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userParameterCheck = _React$useState4[0],
    setUserParameterCheck = _React$useState4[1];
  var _React$useState5 = React.useState({
      label: "All Activity",
      value: "all"
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    activityParameterCheck = _React$useState6[0],
    setActivityParameterCheck = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoaded = _React$useState8[0],
    setIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMore = _React$useState10[0],
    setIsLoadingMore = _React$useState10[1];
  var _useQuery = useQuery(INPUT_ACTIVITY_REPORT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck.value,
        startDate: Number(moment(startDate).startOf("day").format("x")),
        endDate: Number(moment(startDate).endOf("day").format("x")),
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        activityType: activityParameterCheck.value
      }
    }),
    activityReportLoading = _useQuery.loading,
    activityReportData = _useQuery.data,
    activityReportError = _useQuery.error,
    activityReportFetchMore = _useQuery.fetchMore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, organisationBilling.planName != "free" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputActivityHeader, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    startDate: startDate,
    setStartDate: setStartDate,
    organisationBilling: organisationBilling,
    organisationId: organisationId,
    role: role,
    teamId: teamId,
    organisationSettings: organisationSettings,
    activityParameterCheck: activityParameterCheck,
    setActivityParameterCheck: setActivityParameterCheck
  }), /*#__PURE__*/React.createElement(InputActivityDetails, {
    startDate: startDate,
    setStartDate: setStartDate,
    organisationBilling: organisationBilling,
    organisationId: organisationId,
    teamId: teamId,
    userParameterCheck: userParameterCheck,
    organisationSettings: organisationSettings,
    activityReportLoading: activityReportLoading,
    activityReportData: activityReportData,
    activityReportError: activityReportError,
    activityReportFetchMore: activityReportFetchMore,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    activityParameterCheck: activityParameterCheck
  })) : /*#__PURE__*/React.createElement(PlanUpgradeMessage, {
    displayName: user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history
  }));
};
var InputActivityHeader = function InputActivityHeader(props) {
  var userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    startDate = props.startDate,
    setStartDate = props.setStartDate,
    organisationBilling = props.organisationBilling,
    organisationId = props.organisationId,
    role = props.role,
    teamId = props.teamId,
    organisationSettings = props.organisationSettings,
    activityParameterCheck = props.activityParameterCheck,
    setActivityParameterCheck = props.setActivityParameterCheck;
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    exportButton = _React$useState12[0],
    setExportButton = _React$useState12[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    userList = _useState2[0],
    setUserList = _useState2[1];
  var _useQuery2 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery2.loading,
    userListData = _useQuery2.data,
    userListError = _useQuery2.error;
  React.useEffect(function () {
    if (userListData !== null && userListData !== void 0 && userListData.getUserListing) {
      var _userListData$getUser;
      var memberData = userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
        var userId = item.userId,
          displayName = item.displayName;
        return {
          label: displayName,
          value: userId
        };
      });
      setUserList(_toConsumableArray(memberData));
    }
  }, [userListData]);
  var activityLevelList = [{
    label: "All Activity",
    value: "all"
  }, {
    label: "Low",
    value: "low"
  }, {
    label: "Medium",
    value: "medium"
  }, {
    label: "High",
    value: "high"
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-new-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "daily-attendance-filter-user-select",
    classNamePrefix: "Filter By User",
    isLoading: userListLoading,
    loadingMessage: function loadingMessage() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-date-picker"
  }, " ", /*#__PURE__*/React.createElement(DatePicker, {
    selected: startDate,
    onChange: function onChange(date) {
      return setStartDate(date);
    },
    dateFormat: "dd MMM, yyyy",
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? subDays(new Date(), 14) : null
  }))), /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: activityParameterCheck,
    onChange: function onChange(e) {
      return setActivityParameterCheck(e);
    },
    options: activityLevelList,
    className: "daily-attendance-filter-user-select",
    classNamePrefix: "Filter By User"
    // isLoading={userListLoading}
    // loadingMessage={() => <>Loading...</>}
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExportReport, {
    startDate: startDate,
    organisationBilling: organisationBilling,
    organisationId: organisationId,
    userParameterCheck: userParameterCheck,
    organisationSettings: organisationSettings,
    teamId: teamId,
    exportButton: exportButton,
    setExportButton: setExportButton,
    activityParameterCheck: activityParameterCheck
  })));
};
var InputActivityDetails = function InputActivityDetails(props) {
  var _activityReportData$i4;
  var organisationId = props.organisationId,
    teamId = props.teamId,
    userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    organisationSettings = props.organisationSettings,
    activityReportLoading = props.activityReportLoading,
    activityReportData = props.activityReportData,
    activityReportError = props.activityReportError,
    activityReportFetchMore = props.activityReportFetchMore,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    activityParameterCheck = props.activityParameterCheck;
  if (activityReportLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (activityReportError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!activityReportData || (activityReportData === null || activityReportData === void 0 ? void 0 : activityReportData.inputActivityReport.length) == 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, "No data found for this member");
  }
  React.useEffect(function () {
    var _activityReportData$i, _activityReportData$i2;
    if ((activityReportData === null || activityReportData === void 0 ? void 0 : (_activityReportData$i = activityReportData.inputActivityReport) === null || _activityReportData$i === void 0 ? void 0 : _activityReportData$i.length) !== 0 && (activityReportData === null || activityReportData === void 0 ? void 0 : (_activityReportData$i2 = activityReportData.inputActivityReport) === null || _activityReportData$i2 === void 0 ? void 0 : _activityReportData$i2.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [activityReportData === null || activityReportData === void 0 ? void 0 : activityReportData.inputActivityReport]);
  React.useEffect(function () {
    setIsAllLoaded(false);
  }, [userParameterCheck]);
  var columns = [{
    Header: "Time",
    accessor: "time"
  }, {
    Header: "Key Presses",
    accessor: "keyPresses"
  }, {
    Header: "Mouse Clicks",
    accessor: "mouseActions"
  }, {
    Header: "Total Actions",
    accessor: "totalActions"
  }, {
    Header: "Activity Level",
    accessor: "activityLevel"
  }];
  var handleLoadMore = function handleLoadMore() {
    var _activityReportData$i3;
    if (activityReportLoading) return;
    setIsLoadingMore(true);
    activityReportFetchMore({
      variables: {
        offset: activityReportData === null || activityReportData === void 0 ? void 0 : (_activityReportData$i3 = activityReportData.inputActivityReport) === null || _activityReportData$i3 === void 0 ? void 0 : _activityReportData$i3.length
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$inpu, _fetchMoreResult$inpu2;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$inpu = fetchMoreResult.inputActivityReport) === null || _fetchMoreResult$inpu === void 0 ? void 0 : _fetchMoreResult$inpu.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$inpu2 = fetchMoreResult.inputActivityReport) === null || _fetchMoreResult$inpu2 === void 0 ? void 0 : _fetchMoreResult$inpu2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          inputActivityReport: [].concat(_toConsumableArray(prev.inputActivityReport), _toConsumableArray(fetchMoreResult.inputActivityReport))
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActivityTrendChart, {
    activityReportLoading: activityReportLoading,
    activityReportData: activityReportData,
    organisationSettings: organisationSettings
  }), /*#__PURE__*/React.createElement(ActivityHeaderCard, {
    organisationId: organisationId,
    teamId: teamId,
    userParameterCheck: userParameterCheck,
    startDate: startDate,
    organisationSettings: organisationSettings,
    activityParameterCheck: activityParameterCheck
  }), /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-content-new input-activity-report-wrapper"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, (activityReportData === null || activityReportData === void 0 ? void 0 : activityReportData.inputActivityReport.length) != 0 ? /*#__PURE__*/React.createElement("table", {
    className: "daily-attendance-table input-ativity-report-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (column) {
    // Add the sorting props to control sorting. For this example
    // we can add them into the header props
    //console.log("column", column);
    return /*#__PURE__*/React.createElement("th", null, column.Header);
  }))), /*#__PURE__*/React.createElement("tbody", null, activityReportData === null || activityReportData === void 0 ? void 0 : (_activityReportData$i4 = activityReportData.inputActivityReport) === null || _activityReportData$i4 === void 0 ? void 0 : _activityReportData$i4.map(function (row) {
    var totalCount = row.keypressCount + row.mouseEventCount;

    // let activityLevel =
    //   totalCount >= 0 && totalCount <= 9
    //     ? "Low"
    //     : totalCount >= 10 && totalCount <= 29
    //     ? "Medium"
    //     : "High";

    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, moment.unix(row.addedAt / 1000).tz(organisationSettings.organisationTimezone).format("hh:mm A")), /*#__PURE__*/React.createElement("td", null, row.keypressCount), /*#__PURE__*/React.createElement("td", null, row.mouseEventCount), /*#__PURE__*/React.createElement("td", null, totalCount), /*#__PURE__*/React.createElement("td", null, " ", /*#__PURE__*/React.createElement(Badge, {
      pill: true,
      variant: row.activityLevel == "Low" ? "danger" : row.activityLevel == "Medium" ? "primary" : "success",
      className: "\n                          ".concat(row.activityLevel == "low" ? "low-activity-level" : row.activityLevel == "medium" ? "primary-activity-level" : "success-activity-level", " input-type-report-activity-level")
    }, row.activityLevel)));
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, " ", /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data")))));
};
var ExportReport = function ExportReport(props) {
  var organisationId = props.organisationId,
    teamId = props.teamId,
    userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    organisationSettings = props.organisationSettings,
    organisationBilling = props.organisationBilling,
    exportButton = props.exportButton,
    setExportButton = props.setExportButton,
    activityParameterCheck = props.activityParameterCheck;
  var _useLazyQuery = useLazyQuery(INPUT_ACTIVITY_REPORT_EXPORT_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userParameterCheck.value,
                startDate: Number(moment(startDate).startOf("day").format("x")),
                endDate: Number(moment(startDate).endOf("day").format("x")),
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                activityType: activityParameterCheck === null || activityParameterCheck === void 0 ? void 0 : activityParameterCheck.value
              }
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var dataArray, dataValues, wb, ws, col, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dataArray = [];
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.inputActivityReportExport;
          if (dataValues) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          col = [{
            header: "Time",
            key: "time",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Key Presses",
            key: "keyPresses",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Mouse Clicks",
            key: "mouseActions",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Total Actions",
            key: "totalActions",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Activity Level",
            key: "activityLevel",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          ws.columns = col;
          dataValues.map(function (payroll, index) {
            var keypressCount = payroll.keypressCount,
              mouseEventCount = payroll.mouseEventCount,
              addedAt = payroll.addedAt,
              activityLevel = payroll.activityLevel;
            var totalCount = keypressCount + mouseEventCount;

            // let activityLevel =
            //   totalCount >= 0 && totalCount <= 9 ? "Low" : totalCount >= 10 && totalCount <= 29 ? "Medium" : "High";

            ws.addRow({
              time: moment.unix(addedAt / 1000).format("hh:mm A"),
              keyPresses: keypressCount,
              mouseActions: mouseEventCount,
              totalActions: totalCount,
              activityLevel: activityLevel
            });
          });
          ws.getRow(1).font = {
            bold: true
          };
          _context2.next = 12;
          return wb.xlsx.writeBuffer();
        case 12:
          buf = _context2.sent;
          fileName = "workfolio-input-activity-report-".concat(moment(startDate).format("DD-MMM-yyyy"), ".xlsx"); // if (endDate != null) {
          //   fileName = `workfolio-input-activity-report-${moment(Number(startDate)).format("DD-MMM-yyyy")}-${moment(
          //     Number(endDate)
          //   ).format("DD-MMM-yyyy")}.xlsx`;
          // }
          saveAs(new Blob([buf]), fileName);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(BootstrapTooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export")));
};
var ActivityTrendChart = function ActivityTrendChart(props) {
  var _activityReportData$i5;
  var activityReportLoading = props.activityReportLoading,
    activityReportData = props.activityReportData,
    organisationSettings = props.organisationSettings;
  var lebelValue = [];
  var totalActionDatas = [];
  var breakTimeDatas = [];
  var keyPressDatas = [];
  var mouseActionDatas = [];
  var activityLevelDatas = [];
  activityReportData === null || activityReportData === void 0 ? void 0 : (_activityReportData$i5 = activityReportData.inputActivityReport) === null || _activityReportData$i5 === void 0 ? void 0 : _activityReportData$i5.map(function (item) {
    var keypressCount = item.keypressCount,
      mouseEventCount = item.mouseEventCount,
      addedAt = item.addedAt,
      activityLevel = item.activityLevel;
    var totalCount = keypressCount + mouseEventCount;
    lebelValue.push(moment.unix(addedAt / 1000).tz(organisationSettings.organisationTimezone).format("HH:mm"));
    totalActionDatas.push(totalCount);
    breakTimeDatas.push(null);
    keyPressDatas.push(keypressCount);
    mouseActionDatas.push(mouseEventCount);
    activityLevelDatas.push(activityLevel);
  });

  //   console.log({ lebelValue, totalActionDatas, breakTimeDatas });

  var data = {
    // labels: ["09:00", "09:15", "09:30", "09:45", "10:00", "10:15", "10:30", "10:45", "11:00", "11:15"],
    labels: lebelValue,
    datasets: [{
      label: "Total Actions",
      // data: [60, 40, 20, 45, 70, 65, 30, 10, 55, 40],
      data: totalActionDatas,
      fill: true,
      backgroundColor: "rgba(66, 153, 225, 0.1)",
      borderColor: "#4299e1",
      tension: 0.4,
      pointRadius: 2
    },
    //   {
    //     label: "Break Time",
    //     // data: [null, null, null, null, null, null, null, null, null, 0], // simulate a break at 11:15
    //     data: breakTimeDatas, // simulate a break at 11:15
    //     borderColor: "orange",
    //     borderDash: [5, 5],
    //     pointRadius: 0,
    //     tension: 0.4,
    //   },
    {
      label: "__key_presses",
      // internal label
      data: keyPressDatas,
      hidden: true // no line drawn
    }, {
      label: "__mouse_actions",
      // internal label
      data: mouseActionDatas,
      hidden: true
    }, {
      label: "__activity",
      // internal label
      data: activityLevelDatas,
      hidden: true
    }]
  };
  var options = {
    plugins: {
      legend: {
        labels: {
          filter: function filter(legendItem) {
            // Only allow specific dataset labels to show in legend
            return !legendItem.text.startsWith("__");
          }
        }
      },
      tooltip: {
        callbacks: {
          title: function title(tooltipItems) {
            return "Time: ".concat(tooltipItems[0].label);
          },
          label: function label() {
            return null;
          },
          // don't show default
          afterLabel: function afterLabel(tooltipItem) {
            var _data$datasets$find, _data$datasets$find$d, _data$datasets$find2, _data$datasets$find2$, _data$datasets$find3, _data$datasets$find3$;
            var index = tooltipItem.dataIndex;
            var key = ((_data$datasets$find = data.datasets.find(function (ds) {
              return ds.label === "__key_presses";
            })) === null || _data$datasets$find === void 0 ? void 0 : (_data$datasets$find$d = _data$datasets$find.data) === null || _data$datasets$find$d === void 0 ? void 0 : _data$datasets$find$d[index]) || 0;
            var mouse = ((_data$datasets$find2 = data.datasets.find(function (ds) {
              return ds.label === "__mouse_actions";
            })) === null || _data$datasets$find2 === void 0 ? void 0 : (_data$datasets$find2$ = _data$datasets$find2.data) === null || _data$datasets$find2$ === void 0 ? void 0 : _data$datasets$find2$[index]) || 0;
            var activity = ((_data$datasets$find3 = data.datasets.find(function (ds) {
              return ds.label === "__activity";
            })) === null || _data$datasets$find3 === void 0 ? void 0 : (_data$datasets$find3$ = _data$datasets$find3.data) === null || _data$datasets$find3$ === void 0 ? void 0 : _data$datasets$find3$[index]) || 0;
            activity = activity.charAt(0).toUpperCase() + activity.slice(1);
            var total = tooltipItem.raw || 0;
            //  let activity = total >= 0 && total <= 9 ? "Low" : total >= 10 && total <= 29 ? "Medium" : "High";

            return ["\uD83D\uDD35 Key Presses: ".concat(key), "\uD83D\uDFE2 Mouse Clicks: ".concat(mouse), "", "Total Actions: ".concat(total), "Activity: ".concat(activity)];
          }
        },
        displayColors: false,
        backgroundColor: "#fff",
        borderColor: "#e2e8f0",
        borderWidth: 1,
        titleColor: "#1a202c",
        bodyColor: "#1a202c",
        padding: 12
      }
    },
    interaction: {
      mode: "index",
      intersect: false
    }
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "p-3 input-activity-report-chart-card"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "input-activity-report-chart-title"
  }, "Activity Trend"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted input-activity-report-chart-sub-title"
  }, "Hourly breakdown of key and mouse activity"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Line, {
    data: data,
    options: options,
    height: 100
  })));
};
var ActivityHeaderCard = function ActivityHeaderCard(props) {
  var _activityHeaderData$i, _activityHeaderData$i2, _activityHeaderData$i3, _activityHeaderData$i4;
  var organisationId = props.organisationId,
    teamId = props.teamId,
    userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    organisationSettings = props.organisationSettings,
    activityParameterCheck = props.activityParameterCheck;
  var _useQuery3 = useQuery(INPUT_ACTIVITY_REPORT_HEADER_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck.value,
        startDate: Number(moment(startDate).startOf("day").format("x")),
        endDate: Number(moment(startDate).endOf("day").format("x")),
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        activityType: activityParameterCheck === null || activityParameterCheck === void 0 ? void 0 : activityParameterCheck.value
      }
    }),
    activityHeaderLoading = _useQuery3.loading,
    activityHeaderData = _useQuery3.data,
    activityHeaderError = _useQuery3.error;
  return /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card-title text-dark"
  }, "Low Activity Count"), /*#__PURE__*/React.createElement("h6", {
    className: "input-activity-report-dashboard-card-value mb-0 mt-1 font-weight-bold text-dark"
  }, activityHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : activityHeaderError ? "Error" : activityHeaderData === null || activityHeaderData === void 0 ? void 0 : (_activityHeaderData$i = activityHeaderData.inputActivityReportHeader) === null || _activityHeaderData$i === void 0 ? void 0 : _activityHeaderData$i.lowCount)), /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card-title text-dark"
  }, "Medium Activity Count"), /*#__PURE__*/React.createElement("h6", {
    className: "input-activity-report-dashboard-card-value mb-0 mt-1 font-weight-bold text-dark"
  }, activityHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : activityHeaderError ? "Error" : activityHeaderData === null || activityHeaderData === void 0 ? void 0 : (_activityHeaderData$i2 = activityHeaderData.inputActivityReportHeader) === null || _activityHeaderData$i2 === void 0 ? void 0 : _activityHeaderData$i2.mediumCount)), /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card-title text-dark"
  }, "High Activity Count"), /*#__PURE__*/React.createElement("h6", {
    className: "input-activity-report-dashboard-card-value mb-0 mt-1 font-weight-bold text-dark"
  }, activityHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : activityHeaderError ? "Error" : activityHeaderData === null || activityHeaderData === void 0 ? void 0 : (_activityHeaderData$i3 = activityHeaderData.inputActivityReportHeader) === null || _activityHeaderData$i3 === void 0 ? void 0 : _activityHeaderData$i3.highCount)), /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-activity-report-dashboard-card-title text-dark"
  }, "Activity Level"), /*#__PURE__*/React.createElement("h6", {
    className: "input-activity-report-dashboard-card-value mb-0 mt-1 font-weight-bold text-dark"
  }, activityHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : activityHeaderError ? "Error" : activityHeaderData === null || activityHeaderData === void 0 ? void 0 : (_activityHeaderData$i4 = activityHeaderData.inputActivityReportHeader) === null || _activityHeaderData$i4 === void 0 ? void 0 : _activityHeaderData$i4.activityLevel)));
};
export default InputActivityReport;